/**
 * Autocomplete
 * some extensions for the current plugin WCAS (WooCommerce Ajax Search)
 * - Disable Enter Key to prevent submitting form
 * - Display most asked CCN on click
 */
import $ from "jquery";

// Autocomplete Input
const input = document.querySelector('.dgwt-wcas-no-submit .dgwt-wcas-search-input');

if (input) {

  // Disable Enter Key to prevent submitting form
  $(input).keypress(function(ev) {
    const code = (ev.keyCode ? ev.keyCode : ev.which);

    if (code == 13) { // Enter keycode
      return false;
    }
  })

}
